import React from 'react'
import  {Routes, Route} from "react-router-dom";
import StudentHome from '../home/studentHome/StudentHome';
import Teachers from '../pages/teacherPages/teachersList/Teachers';
import TeacherDetails from '../pages/teacherPages/teachersList/TeacherDetails';
import StudentClasses from '../pages/teacherPages/classes/studentClasses/StudentClasses';
import LessonCalendar from "../pages/calendars/LessonCalendar";
import Profile from "../pages/teacherPages/profile/Profile";
import LessonInfo from "../pages/teacherPages/lessonInfo/LessonInfo";
import Feedback from "../pages/feedback/Feedback";
import MyLessons from "../pages/teacherPages/classes/studentClasses/studentLessons/MyLessons"
import CompletedLessons from '../pages/teacherPages/classes/studentClasses/CompletedLessons';
import TeachingVideos from '../pages/teacherPages/videos/TeachingVideos';
import StudentProfile from '../pages/teacherPages/profile/studentProfile/StudentProfile';
import AwaitingLessons from '../pages/teacherPages/classes/studentClasses/AwaitingLessons';
import TodayLessons from '../pages/teacherPages/classes/studentClasses/TodayLessons';
import Reviews from '../pages/teacherPages/classes/studentClasses/Reviews';
import Contact from '../pages/contact/Contact';
import Navbar from '../components/navbar/Navbar';
import LessonRoom from '../pages/lessonRoom/LessonRoom';
const StudentRouter = () => {
  return (  
    <> 
    <Navbar/>
    <Routes>
      <Route path='/home' element={<StudentHome />}/>
        <Route path='/teachers' element={<Teachers/>}/>
        <Route path='/teachers/:userId' element={<TeacherDetails />} />
        <Route path='/student-classes' element={<StudentClasses/>}/>
        <Route path='/calendar' element={<LessonCalendar />} />
        <Route path='/profile' element={<Profile />} />
        <Route path='/lessoninfo' element={<LessonInfo />} />
        <Route path='/feedback' element={<Feedback />} />
        <Route path='/my-lessons' element={<MyLessons />} />
        <Route path='/completed-lessons' element={<CompletedLessons />} />
        <Route path='/teaching-videos' element={<TeachingVideos />} />
        <Route path='/student-profile' element={<StudentProfile />} />
        <Route path='/awaiting-lessons' element={<AwaitingLessons />} />
        <Route path='/todays-lessons' element={<TodayLessons />} />
        <Route path='/reviews' element={<Reviews />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/lesson/:eventId' element={<LessonRoom />} />
    </Routes>
    </>
  )
}

export default StudentRouter
